import React from 'react';
import { Link } from 'react-router-dom';

const s = {
  page: { paddingTop: '64px' },

  // ── Hero ──────────────────────────────────────────────────────────────────
  hero: {
    minHeight: '90vh', display: 'flex', flexDirection: 'column',
    justifyContent: 'center', padding: '80px 80px 80px',
    maxWidth: '680px',
  },
  eyebrow: {
    fontSize: '0.72rem', fontWeight: 500, letterSpacing: '0.18em',
    textTransform: 'uppercase', color: 'var(--amber)',
    marginBottom: '24px', display: 'flex', alignItems: 'center', gap: '12px',
  },
  eyebrowLine: {
    display: 'block', width: '32px', height: '1px', background: 'var(--amber)',
  },
  title: {
    fontFamily: 'var(--font-display)', fontSize: 'clamp(2.8rem, 5vw, 4.2rem)',
    fontWeight: 600, lineHeight: 1.08, color: 'var(--navy)',
    marginBottom: '28px',
  },
  em: { fontStyle: 'italic', color: 'var(--amber)' },
  sub: {
    fontSize: '1rem', fontWeight: 300, lineHeight: 1.75,
    color: '#374151', maxWidth: '480px', marginBottom: '44px',
  },
  cta: {
    display: 'inline-block', background: 'var(--navy)', color: 'var(--white)',
    padding: '14px 36px', borderRadius: '4px', fontSize: '0.9rem',
    fontWeight: 500, letterSpacing: '0.03em',
  },

  // ── Credential Cards ──────────────────────────────────────────────────────
  credSection: {
    padding: '80px 0', background: 'var(--white)',
    borderTop: '1px solid var(--border)',
  },
  credInner: {
    maxWidth: '1100px', margin: '0 auto', padding: '0 80px',
  },
  credEyebrow: {
    fontSize: '0.72rem', fontWeight: 500, letterSpacing: '0.18em',
    textTransform: 'uppercase', color: 'var(--amber)',
    marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '12px',
  },
  credHeadline: {
    fontFamily: 'var(--font-display)', fontSize: 'clamp(1.6rem, 3vw, 2.4rem)',
    fontWeight: 600, color: 'var(--navy)', marginBottom: '12px', lineHeight: 1.15,
  },
  credLead: {
    fontSize: '0.95rem', fontWeight: 300, color: '#4B5563',
    lineHeight: 1.8, maxWidth: '560px', marginBottom: '48px',
  },
  cardGrid: {
    display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px',
  },
  cardNavy: {
    background: 'var(--navy)', borderRadius: '16px',
    padding: '48px', display: 'flex', flexDirection: 'column',
    justifyContent: 'space-between', minHeight: '320px',
  },
  cardAmber: {
    background: 'var(--amber)', borderRadius: '16px',
    padding: '48px', display: 'flex', flexDirection: 'column',
    justifyContent: 'space-between', minHeight: '320px',
  },
  cardTop: {},
  cardIcon: { fontSize: '2.4rem', marginBottom: '20px', display: 'block' },
  cardTitle: {
    fontFamily: 'var(--font-display)', fontSize: '1.8rem',
    fontWeight: 600, color: 'white', lineHeight: 1.1, marginBottom: '14px',
  },
  cardBody: {
    fontSize: '0.9rem', fontWeight: 300, color: 'rgba(255,255,255,0.78)',
    lineHeight: 1.75,
  },
  cardStats: {
    display: 'flex', gap: '24px', marginTop: '28px', flexWrap: 'wrap',
  },
  cardStat: {},
  cardStatNum: {
    fontSize: '1.6rem', fontWeight: 700, color: 'white', lineHeight: 1,
  },
  cardStatLabel: {
    fontSize: '0.68rem', color: 'rgba(255,255,255,0.55)',
    letterSpacing: '0.08em', textTransform: 'uppercase', marginTop: '2px',
  },
  cardLink: {
    marginTop: '32px', display: 'inline-flex', alignItems: 'center', gap: '8px',
    color: 'white', fontWeight: 600, fontSize: '0.88rem',
    borderTop: '1px solid rgba(255,255,255,0.25)', paddingTop: '20px',
    letterSpacing: '0.02em',
  },
  cardArrow: { fontSize: '1.1rem' },

  // ── Final CTA ─────────────────────────────────────────────────────────────
  ctaSection: {
    padding: '100px 0 80px', background: 'var(--cream)', textAlign: 'center',
  },
  ctaEyebrow: {
    fontSize: '0.72rem', fontWeight: 500, letterSpacing: '0.18em',
    textTransform: 'uppercase', color: 'var(--amber)',
    marginBottom: '16px', display: 'flex', alignItems: 'center',
    justifyContent: 'center', gap: '12px',
  },
  ctaTitle: {
    fontFamily: 'var(--font-display)', fontSize: 'clamp(1.8rem, 3vw, 2.6rem)',
    fontWeight: 600, color: 'var(--navy)', textAlign: 'center',
    maxWidth: '560px', margin: '0 auto 16px', lineHeight: 1.15,
  },
  ctaLead: {
    fontSize: '0.95rem', fontWeight: 300, color: '#4B5563',
    lineHeight: 1.8, textAlign: 'center', margin: '0 auto 44px',
    maxWidth: '480px',
  },


  // ── Two-column hero layout ───────────────────────────────────────────────
  heroGrid: {
    maxWidth: '1200px', margin: '0 auto',
    display: 'grid', gridTemplateColumns: '1fr 1fr',
    gap: '72px', alignItems: 'center',
    padding: '80px 80px',
    minHeight: '92vh',
  },
  heroLeft: {},
  heroRight: { display: 'flex', flexDirection: 'column', gap: '20px' },

  // ── White panel cards (Option A) ────────────────────────────────────────
  panelCard: (borderColor) => ({
    background: 'white',
    borderRadius: '12px',
    border: '1px solid var(--border)',
    borderLeft: `4px solid ${borderColor}`,
    padding: '28px 32px',
    boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
    textDecoration: 'none',
    display: 'block',
    transition: 'box-shadow 0.2s, transform 0.2s',
  }),
  panelIcon: { fontSize: '1.5rem', marginBottom: '10px', display: 'block' },
  panelTitle: {
    fontFamily: 'var(--font-display)', fontSize: '1.25rem',
    fontWeight: 600, color: 'var(--navy)', marginBottom: '8px',
  },
  panelBody: {
    fontSize: '0.85rem', fontWeight: 300, color: '#4B5563',
    lineHeight: 1.7, marginBottom: '16px',
  },
  panelStats: { display: 'flex', gap: '24px', marginBottom: '16px' },
  panelStat: {},
  panelStatNum: (color) => ({
    fontSize: '1.4rem', fontWeight: 700, color: color, lineHeight: 1,
  }),
  panelStatLabel: {
    fontSize: '0.65rem', color: 'var(--muted)',
    letterSpacing: '0.08em', textTransform: 'uppercase', marginTop: '2px',
  },
  panelLink: (color) => ({
    fontSize: '0.8rem', fontWeight: 600, color: color,
    display: 'flex', alignItems: 'center', gap: '6px',
    paddingTop: '14px', borderTop: '1px solid var(--border)',
  }),

  // ── Compliance + Footer ───────────────────────────────────────────────────
  compliance: {
    background: '#FFFBEB', borderTop: '1px solid #FDE68A',
    borderBottom: '1px solid #FDE68A', padding: '24px 0',
  },
  complianceInner: {
    maxWidth: '1100px', margin: '0 auto', padding: '0 80px',
    display: 'flex', gap: '20px', alignItems: 'flex-start',
  },
  complianceText: {
    fontSize: '0.8rem', color: '#92400E', lineHeight: 1.65, fontWeight: 300,
  },
  footer: {
    background: 'var(--cream)', borderTop: '1px solid var(--border)',
    padding: '36px 0',
  },
  footerInner: {
    maxWidth: '1100px', margin: '0 auto', padding: '0 80px',
    display: 'flex', justifyContent: 'space-between',
    alignItems: 'center', flexWrap: 'wrap', gap: '16px',
  },
  footerBrand: {
    fontFamily: 'var(--font-display)', fontSize: '1rem', fontWeight: 600,
    color: 'var(--navy)', letterSpacing: '0.04em', textTransform: 'uppercase',
  },
  footerLinks: {
    display: 'flex', gap: '24px', alignItems: 'center',
  },
  footerLink: {
    fontSize: '0.8rem', color: 'var(--muted)', fontWeight: 400,
  },
  footerNote: {
    fontSize: '0.74rem', color: 'var(--muted)',
    maxWidth: '480px', lineHeight: 1.6, textAlign: 'right',
  },
};

export default function HowItWorks() {
  return (
    <div style={s.page}>

      {/* ── Hero: two-column ── */}
      <div style={s.heroGrid}>

        {/* Left: headline + CTA */}
        <div style={s.heroLeft}>
          <div style={s.eyebrow}><span style={s.eyebrowLine} />Lifestyle Intelligence Hub</div>
          <h1 style={s.title}>
            One assessment.<br />
            Your <em style={s.em}>complete</em><br />
            picture, instantly.
          </h1>
          <p style={s.sub}>
            Answer a few questions about your health, lifestyle, and goals.
            In moments you have a personalized lifestyle guidance report across 15 lifestyle domains and a personalized supplement protocol — and a coach who already knows both.
          </p>
          <p style={{ fontSize: '0.82rem', fontWeight: 300, lineHeight: 1.7, color: '#6B7280', maxWidth: '480px', marginTop: '-28px', marginBottom: '44px' }}>
            The Lifestyle Intelligence Hub was created by Bob Ferguson — someone who has spent a lifetime studying what makes people genuinely healthy, energized, and fulfilled. This is what 54 years of practice looks like when you decide to share it.
          </p>
          <Link to="/assessment" style={s.cta}>Begin My Assessment</Link>
        </div>

        {/* Right: white panel cards */}
        <div style={s.heroRight}>

          {/* How This Was Built */}
          <Link to="/how-it-was-built" style={s.panelCard('var(--navy)')}>
            <span style={s.panelIcon}>🏗</span>
            <div style={s.panelTitle}>How This Was Built</div>
            <div style={s.panelBody}>
              The methodology, the reasoning, and the science behind every recommendation —
              who built it, why, and what it's grounded in.
            </div>
            <div style={s.panelStats}>
              <div style={s.panelStat}>
                <div style={s.panelStatNum('var(--navy)')}>37</div>
                <div style={s.panelStatLabel}>Nutrition domains</div>
              </div>
              <div style={s.panelStat}>
                <div style={s.panelStatNum('var(--navy)')}>180</div>
                <div style={s.panelStatLabel}>Graded studies</div>
              </div>

            </div>
            <div style={s.panelLink('var(--navy)')}>Read the methodology →</div>
          </Link>

          {/* The Science */}
          <Link to="/science" style={s.panelCard('var(--amber)')}>
            <span style={s.panelIcon}>🔬</span>
            <div style={s.panelTitle}>The Science</div>
            <div style={s.panelBody}>
              Every study behind this tool, graded by evidence strength and organized
              by domain. Follow the evidence behind any recommendation.
            </div>
            <div style={s.panelStats}>
              <div style={s.panelStat}>
                <div style={s.panelStatNum('var(--amber)')}>37</div>
                <div style={s.panelStatLabel}>Research domains</div>
              </div>
              <div style={s.panelStat}>
                <div style={s.panelStatNum('var(--amber)')}>180</div>
                <div style={s.panelStatLabel}>Graded studies</div>
              </div>
              <div style={s.panelStat}>
                <div style={s.panelStatNum('var(--amber)')}>A–EO</div>
                <div style={s.panelStatLabel}>Evidence grades</div>
              </div>
            </div>
            <div style={s.panelLink('var(--amber)')}>Browse the research →</div>
          </Link>

        </div>
      </div>

      {/* ── Beat 3: Final CTA ── */}
      <section style={s.ctaSection}>
        <div style={s.ctaEyebrow}>
          <span style={s.eyebrowLine} />Ready to begin
        </div>
        <h2 style={s.ctaTitle}>Your complete picture<br />is four minutes away.</h2>
        <p style={s.ctaLead}>
          Start the assessment. Get your protocol instantly.
          Decide how deep you want to go from there.
        </p>
        <Link to="/assessment" style={s.cta}>Begin My Assessment</Link>
      </section>

      {/* ── Compliance ── */}
      <div style={s.compliance}>
        <div style={s.complianceInner}>
          <span style={{ fontSize: '1.3rem', flexShrink: 0 }}>⚖️</span>
          <p style={s.complianceText}>
            <strong>A note on supplement language.</strong> These statements have not been evaluated
            by the Food and Drug Administration. Products recommended through this tool are not
            intended to diagnose, treat, cure, or prevent any disease. This tool is authored by an
            independent Shaklee distributor, not Shaklee Corporation. Always consult a qualified
            healthcare professional before beginning any supplement program.
          </p>
        </div>
      </div>

      {/* ── Footer ── */}
      <footer style={s.footer}>
        <div style={s.footerInner}>
          <div style={s.footerBrand}>Lifestyle Intelligence Hub</div>
          <div style={s.footerLinks}>
            <Link to="/how-it-was-built" style={s.footerLink}>How This Was Built</Link>
            <Link to="/science" style={s.footerLink}>The Science</Link>
          </div>
          <div style={s.footerNote}>
            Authored and operated by an independent Shaklee distributor. Not affiliated with or
            authorized by Shaklee Corporation. These statements have not been evaluated by the FDA.
          </div>
        </div>
      </footer>

    </div>
  );
}
